// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__3GNzX","wrapper":"Content_wrapper__16j4A"};